import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export interface LayerGroupContextMenuProps {
	anchorEl?: HTMLElement | null;
	onClose?: () => void;
	open?: boolean;
	visible?: boolean;
	onDelete?: () => void;
	isEmptyLayerGroup?: boolean;
	onVisibilityChange?: (visible: boolean) => void;
	disableDelete?: boolean;
	onAddLayerGroup?: (position: "above" | "below") => void;
}

export function LayerGroupContextMenu({
	anchorEl,
	onClose,
	open = false,
	onDelete,
	visible,
	isEmptyLayerGroup,
	onVisibilityChange,
	disableDelete,
	onAddLayerGroup,
}: LayerGroupContextMenuProps) {
	return (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
			onClose={onClose}
			open={open}
			transformOrigin={{ horizontal: "right", vertical: "top" }}>
			<MenuItem
				onClick={() => {
					onVisibilityChange?.(!visible);
				}}>
				<Checkbox checked={visible} />
				Change layer group visibility
			</MenuItem>
			<Divider />
			{!isEmptyLayerGroup && [
				<MenuItem
					key="insert-group-above"
					onClick={() => onAddLayerGroup?.("above")}>
					Insert Layer Group above
				</MenuItem>,
				<MenuItem
					key="insert-group-below"
					onClick={() => onAddLayerGroup?.("below")}>
					Insert Layer Group below
				</MenuItem>,
				<Divider key="insert-group-divider" />,
			]}
			<MenuItem
				onClick={onDelete}
				sx={{ color: "var(--mui-palette-error-main)" }}
				disabled={!isEmptyLayerGroup || disableDelete}>
				Delete Layer Group
			</MenuItem>
		</Menu>
	);
}
